export enum PRIMARY_TAB_INDICES {
  Home = 0,
  Categories = 1,
  Segments = 2,
  Topics = 3,
  Brands = 4,
  Advertising = 5,
  Finance = 6,
  Generation = 7,
  Shelf = 8
}

export enum ATLAS_V2_TAB_INDICES {
  Home = 0,
  Categories = 1,
  Segments = 2,
  Topics = 3,
  Brands = 4,
  Shelf = 5
}
